const getProductNameFromUrl = (url: string, productIdExtractCode: string | undefined): string | undefined => {
  const urlParts = new URL(url).pathname.split('/');
  // TODO: need to check line 4 to 5
  if (productIdExtractCode) {
    const map = new Function('url', productIdExtractCode);
    return map(url);
  }

  if (urlParts[urlParts.length - 1] !== '') {
    return urlParts[urlParts.length - 1];
  }

  if (urlParts[urlParts.length - 2] !== '') {
    return urlParts[urlParts.length - 2];
  }
};
export default getProductNameFromUrl;
